



























































































































import {Component, Prop, Vue} from 'vue-property-decorator'
import NavbarWalletStatusIcon from '@/components/navbar/NavbarWalletStatusIcon.vue'
import {$} from '@/facade'

@Component({
  components: {
    NavbarWalletStatusIcon,
  },
})
export default class NavbarWalletSessionConnectedDropdown extends Vue {
  @Prop({required: true}) n3Address!: string | null
  @Prop({required: true}) xAddress!: string | null

  disconnectN3Wallet() {
    $.walletAdapter.disconnectN3Wallet()
  }

  disconnectXWallet() {
    $.walletAdapter.disconnectXWallet()
  }

  openConnectWalletModal() {
    $.modal.open('connectWalletModal')
  }
}
